<template>

  <div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        value="published"
        v-model="job.publicate">
      <label class="form-check-label">
        {{ $t('Publish') }}
      </label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        value="unlisted"
        v-model="job.publicate">
      <label class="form-check-label">
        {{ $t('Unlisted') }}
      </label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        value="internal"
        v-model="job.publicate">
      <label class="form-check-label">
        {{ $t('Internal') }}
      </label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        value="no"
        v-model="job.publicate">
      <label class="form-check-label">
        {{ $t('Don\'t publish') }}
      </label>
    </div>

    <hr>

    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value="remuneration"
        v-model="job.publicate_display">
      <label class="form-check-label">
        {{ $t('Show remuneration') }}
      </label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value="contract"
        v-model="job.publicate_display">
      <label class="form-check-label">
        {{ $t('Show contract type') }}
      </label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value="benefits"
        v-model="job.publicate_display">
      <label class="form-check-label">
        {{ $t('Show benefits') }}
      </label>
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value="company_description"
        v-model="job.publicate_display">
      <label class="form-check-label">
        {{ $t('Show company description') }} 
      </label>
    </div>

  </div>

</template>

<script>
export default {
  name: 'JobFormPublish',
  components: {
  },
  props: [
    'initJob',
    'validateErrors'
  ],
  data () {
    return {
      job: this.$clone(this.initJob)
    }
  },
  watch: {
    job: {
      handler: function (newValue) {
        const {
          publicate,
          publicate_display
        } = newValue
        this.$emit('changed', {
          publicate,
          publicate_display
        })
      },
      deep: true
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobFormPublish.vue